var map = {
	"./account-activation/account-activation.module": [
		"./src/app/account-activation/account-activation.module.ts",
		"account-activation-account-activation-module"
	],
	"./login.admin/login.module": [
		"./src/app/login.admin/login.module.ts",
		"login-admin-login-module"
	],
	"./login.client/login.module": [
		"./src/app/login.client/login.module.ts",
		"login-client-login-module"
	],
	"./login.reset/reset.module": [
		"./src/app/login.reset/reset.module.ts",
		"login-reset-reset-module"
	],
	"./pages.admin/pages.module": [
		"./src/app/pages.admin/pages.module.ts",
		"default~pages-admin-pages-module~pages-client-pages-module"
	],
	"./pages.client/pages.module": [
		"./src/app/pages.client/pages.module.ts",
		"default~pages-admin-pages-module~pages-client-pages-module",
		"pages-client-pages-module"
	],
	"./password-forget/password-forget.module": [
		"./src/app/password-forget/password-forget.module.ts",
		"password-forget-password-forget-module"
	],
	"./switch-page/switch-page.module": [
		"./src/app/switch-page/switch-page.module.ts",
		"switch-page-switch-page-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;